import { MutationTree } from "vuex";
import { Recipes } from "@/types/recipes";
import { ApplianceData, SearchState, TagGroups } from "@/types/search";
import { Products } from "@/types/common";
import NativeClient from "@/client/native-client";

const mutations: MutationTree<SearchState> = {
  updateRecommendRecipes: (state, recipes: Recipes | null) => {
    state.recommendRecipes = recipes;
  },
  updateRankingRecipes: (state, recipes: Recipes | null) => {
    state.rankingRecipes = recipes;
  },
  updateSearchKeywordRecipes: (state, recipes: Recipes | null) => {
    if (recipes && recipes.recipes && state.searchKeywordRecipes) {
      const mergedRecipes = state.searchKeywordRecipes.recipes.concat(recipes.recipes);
      const newRecipes: Recipes = {
        ...recipes,
        recipes: mergedRecipes
      };
      state.searchKeywordRecipes = newRecipes;
      if (state.searchKeywordRecipes != null) {
        NativeClient.sendDebugLog("updateSearchKeywordRecipes add count=" + state.searchKeywordRecipes.recipes.length);
      }
      return;
    }
    state.searchKeywordRecipes = recipes;
    if (state.searchKeywordRecipes != null) {
      NativeClient.sendDebugLog("updateSearchKeywordRecipes new count=" + state.searchKeywordRecipes.recipes.length);
    }
  },
  updateTagGroups: (state, tagGroups: TagGroups | null) => {
    state.tagGroups = tagGroups;
  },
  updateKeyword: (state, keyword: string | null) => {
    NativeClient.sendDebugLog("updateKeyword keyword=" + keyword);
    state.keyword = keyword;
  },
  updateSortType: (state, sort: string | null) => {
    NativeClient.sendDebugLog("updateSortType sort=" + sort);
    state.sortType = sort;
  },
  updateTags: (state, tags: string | null) => {
    NativeClient.sendDebugLog("updateTags tags=" + tags);
    state.tags = tags;
  },
  updateProducts: (state, products: Products | null) => {
    state.products = products;
  },
  updateApplianceList: (state, applianceList: Array<ApplianceData> | null) => {
    state.applianceList = applianceList;
  }
};

export default mutations;
